import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { ToastConfigService } from '../../../core/services/toast-config/toast-config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { CmsNavbarService } from '../../cms-navbar/cms-navbar.service';
import { ModelMapService } from '../../model-map/model-map.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { AdminService } from '../admin.service';
// import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { NgForm, FormsModule } from '@angular/forms';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BMWListData } from '../../../core/models/bmwListData';
import { MINIListData } from '../../../core/models/miniListData';
import { MOTORRADListData } from '../../../core/models/motorradListData';
import { ROLLSROYCEListData } from '../../../core/models/rollsRoyceListdata';
import { ScopePatternParamsRefDataResponse } from '../../../core/models/scopePatternParamsRefDataResponse';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { DialogService } from '../../../core/services/dialog/dialog.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { ScopePatternService } from '../../scope-pattern/scope-pattern.service';
import { NgIf, NgFor } from '@angular/common';
import { SelectRequiredValidatorDirective } from '../../../shared/directives/select-required-validator.directive';

declare var $: any;
@Component({
    selector: 'app-add-bulletin-for-scope-pattern',
    templateUrl: './add-bulletin-for-scope-pattern.component.html',
    styleUrls: ['./add-bulletin-for-scope-pattern.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, NgIf, SelectRequiredValidatorDirective, NgMultiSelectDropDownModule, NgFor]
})
export class AddBulletinForScopePatternComponent implements OnInit, OnDestroy {
  public bulletinType = '';
  public actionType = '';
  private subscriptions: ISubscription[] = [];
  public makeList;
  public inputMake;
  public inputDate: string;
  public selDate;
  public tkrCode = '';
  public isTakataRecall = false;
  public documentNumber = '';
  public bulletinNumber = '';
  public textareaContent = '';
  public relatedSIBs: string[] = [];
  public setDateFlag: boolean = false;

  public reactivateOrDeactivate: any;
  public isDocActive = false;
  public makeNameForApi: string;
  //  public listMakeName: ParamListItem[];

  public inputSeries = '';
  public inputModel = '';
  public inputEngine = '';

  public inputArea = '';

  public inputChannel: any;
  public channelsList = [];

  public seriesList: any[];
  public seriesFilterList: any[];

  public areaList: any[];
  public areaFilterList: any[];
  public scopePatternParamsRefDataResponse: ScopePatternParamsRefDataResponse;

  public documentNumbersList: any[];
  public obdCategories: any[];
  public docId: number;

  private userEmail: string;

  public errorMessage = '';
  public errorMessageSIB = '';
  public showAllFields: boolean = false;

  public uploadedFileName = 'No File Selected';
  public vimeoID = '';
  public uploadedFile = null;

  public pageTitle: string;

  public allObdData: any[];
  public documentOBDTitle;

  public newUploadFlag: boolean = false;
  public showAllOptionsOBD: boolean = false;
  public showAllOptionsTool: boolean = false;

  public isMotorradAdmin: boolean = false;
  public isRollsRoyceAdmin: boolean = false;
  public isAdmin: boolean = false;
  public isMotorrad: boolean = false;
  public isRollsRoyce: boolean = false;
  public showTakata: boolean = false;
  dropdownESeriesList = [];
  dropdownAreaList = [];
  selectedItems = [];
  BMW?: BMWListData;
  MINI?: MINIListData;
  MOTORRAD?: MOTORRADListData;
  ROLLSROYCE?: ROLLSROYCEListData;
  prevMake?: string;
  currentMake?: string;
  makeSelected?: string;
  //dropdownSettings = {};
  // public sproadicPermanentList = [];
  mouseoverLogin;
  dropdownSettingsSeries: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'seriesName',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettingsArea: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'signalName',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false,

  };

  constructor(
    private cmsNavbarService: CmsNavbarService,
    private toastService: ToastConfigService,
    private adminService: AdminService,
    private modelMapService: ModelMapService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private scopePatternService: ScopePatternService,
    private dialogService: DialogService,
    private analyticsService: AnalyticsService,
    private cdr: ChangeDetectorRef
    //private cmsNavbarService: CmsNavbarService,

  ) { }

  getPageTitle(): string {

    //this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + this.bulletinType.charAt(0).toUpperCase() + this.bulletinType.slice(1));
    this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + "Scope Pattern Library");
    return this.pageTitle;
  }

  public onDropDownClose(item: any) {
  }

  ngOnInit() {
    this.errorMessageSIB = '';
    this.inputChannel = "undefined";

    this.makeSelected = "BMW";
    this.prevMake = "undefined";

    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    if (APP_SETTINGS.isAdmin === 'true') {
      this.isAdmin = true;
    }

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });

    this.pageTitle = '';

    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
    });

    // this.userEmail = 'Chad.Pinson@partner.bmwgroup.com';
    this.documentNumbersList = [];
    this.seriesList = [];

    this.resetFields();
    this.getPageTitle();
    this.bulletinType = this.route.snapshot.paramMap.get('bulletinType');
    this.actionType = this.route.snapshot.paramMap.get('actionType');

    this.areaList = [];
    
    this.subscriptions.push(this.scopePatternService.getAllCatalogs().subscribe(data => {
      this.makeList = data;
    }));

    this.subscriptions.push(this.modelMapService.getAllSeries().subscribe(data => {
      this.seriesList = data;
      this.dropdownESeriesList = this.seriesList;      
    }));
    
    this.subscriptions.push(this.scopePatternService.getAllSignals().subscribe(data => {
      this.areaList = data;
      this.dropdownAreaList = this.areaList;      
    }));
  
    this.setRandomDocNumber();

  }

  populateNoiseParamList() {
    if (this.scopePatternParamsRefDataResponse != null && this.scopePatternParamsRefDataResponse.status.statusCode === 'SUCCESS') {
      this.BMW = this.scopePatternParamsRefDataResponse.scopePatternDataParams.BMW;
      this.MINI = this.scopePatternParamsRefDataResponse.scopePatternDataParams.MINI;
      this.populateNoiseParamListByMake(this.makeSelected);
    }
  }


  onMakeSelectionChanged(event) {

    if (this.makeSelected != "undefined" && this.prevMake != event) {
      if (this.dialogService.confirm('Changing the Make will reset the form entries, all entries will be lost. \n Do you want to continue? ')['value'] === true) {
        this.makeSelected = event;
        this.prevMake = event;
        this.changeMaingroupList(this.makeSelected);
        this.populateNoiseParamListByMake(this.makeSelected);
      }
      else {
        this.makeSelected = this.prevMake;
      }
    }
    if (this.makeSelected == "undefined" && event != "undefined") {
      this.makeSelected = event;
      this.prevMake = event;
      this.changeMaingroupList(this.makeSelected);
      this.populateNoiseParamListByMake(this.makeSelected);
    }

    return this.prevMake;
  }
  changeMaingroupList(makeNameCurrent){
    this.subscriptions.push(this.cmsNavbarService.getMainGroupsListbyMakeName(makeNameCurrent).subscribe(data => {
      this.channelsList = data;
    }));
}

  populateNoiseParamListByMake(makeNameCurrent) {

    this.resetFields();
    if (makeNameCurrent === 'BMW') {
      this.inputMake = 'BMW';
    }
    else if (makeNameCurrent === 'MINI') {
      this.inputMake = 'MINI';
    }

  }

  resetFields() {
    this.inputMake = null;
    this.seriesFilterList = [];
    this.relatedSIBs = [];
    this.uploadedFile = this.inputDate = '';
    this.uploadedFileName = 'No File Selected';
    this.vimeoID = '';
    this.bulletinNumber = this.documentNumber = this.textareaContent = this.tkrCode = '';
    this.isTakataRecall = false;
    this.newUploadFlag = false;
    this.documentNumber = null;
    this.makeNameForApi = undefined;

    //this.areaList = [];
    //this.dropdownAreaList = [];
    this.areaFilterList = [];
    this.inputChannel = "undefined";
  }

  addToSelection(listType: string, listItem: string | object) {
    listItem = listItem !== null && typeof listItem === 'object' ? listItem['engineName'] : listItem;
    if (listItem) {
      switch (listType) {
        case 'sib':
          this.bulletinNumber = '';
          this.addNewBulletin(this.makeSelected, listItem);
          break;
      }
    }
  }

  addNewBulletin(makeSelected, bulletinNumber) {
    this.errorMessageSIB = '';
    if (bulletinNumber) {
      const bulletinId = bulletinNumber.replace(/\s+/g, "");
      this.adminService.findBulletinByNumberMake(bulletinId, makeSelected).subscribe(
        bulletinData => {
          this.relatedSIBs.push(bulletinNumber);
        },
        error => {
          // alert('Please enter valid SIB bulletin.');
          console.error('Error searching bulletin by Numbermake', error);
          this.errorMessageSIB = 'Please enter valid active SIB.';
          //this.errorMessage = error.error.message;
        });
    }
  }


  removeFromSelection(listType: string, listItem: string) {
    switch (listType) {
      case 'sib':
        this.relatedSIBs = this.relatedSIBs.filter(item => item !== listItem);
        break;
    }
  }


  removeFromNoiseSelection(listType: any, listItem: any) {
    switch (listType) {

      case 'series':
        this.seriesFilterList = this.seriesFilterList.filter(item => item !== listItem.seriesName);
        break;
      case 'area':
        this.areaFilterList = this.areaFilterList.filter(item => item !== listItem);
        break;
    }
  }


  addToNoiseSelection(listType: string, listItem: any) {
    listItem = typeof listItem === 'object' ? listItem['engineName'] : listItem;
    if (listItem) {
      switch (listType) {
        case 'series':
          //this.seriesFilterList.push(listItem.seriesName);
          this.inputSeries = '';
          break;
        case 'area':
          this.areaFilterList.push(listItem);
          this.inputArea = '';
          break;    
      }
    }
  }

  fileUpload(fileObj) {
    if (fileObj && fileObj.target.files.length > 0) {
      const file = fileObj.target.files[0];
      const isFileValid = this.utilityService.fileValidator(file.name);
      if (!isFileValid) {
        this.errorMessage = 'File type not supported';
        this.uploadedFile = null;
        this.uploadedFileName = '';
      } else {
        this.errorMessage = '';
        this.uploadedFile = file;
        this.uploadedFileName = file.name;
        this.newUploadFlag = true;
      }
      // Clear the input so picking the same file again still fires a change event
      fileObj.target.value = '';
      this.cdr.markForCheck();
    }
  }

  onSubmit(form: NgForm) {
    
    const selectedSeries = filterSeriesArray(this.seriesList, this.seriesFilterList);
    if(this.documentNumber === '' || 
      this.textareaContent === '' || 
      this.inputDate === '' ||
      selectedSeries.length === 0 ||
      this.areaFilterList.length === 0 ||
      this.uploadedFileName === 'No File Selected' || 
      this.uploadedFileName.length === 0) {
        this.errorMessage = 'All the required (*) fields must be filled before submit';
    } else if (form.valid) {
      this.submit();
    }

  }

  submit() {

    if (this.inputDate == null) {
      this.inputDate = this.setDefaultDate();
    }
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    if (this.actionType === 'add') {
      
      this.spinnerService.show("bmwSpinner");
      if (this.bulletinType === 'scope pattern library') {
        
        const selectedSeries = filterSeriesArray(this.seriesList, this.seriesFilterList);
        const selectedMake = this.makeList.filter(obj => {
          return obj.makeName === this.makeSelected;
        });
        
        const noiseObject = {          
          scopePatternDisplayNumber: this.documentNumber,
          scopePatternTitle: this.textareaContent,
          make: selectedMake[0],
          releaseDate: this.inputDate,
          splDocumentName: "",    
          isActive: true,
          deactivateComments: "",
          createdTs: this.setDefaultDate(),
          updatedTs: this.setDefaultDate(),
          series: selectedSeries,
          signals: this.areaFilterList,          
        };

        this.subscriptions.push(this.adminService.createNewScopePattern(noiseObject).subscribe(value => {
          if (value) {
            const hasFile = this.uploadedFileName !== 'No File Selected' && this.uploadedFileName.length > 0 && this.uploadedFile;
            if (hasFile) {
              const uploadFailedMessage = 'Scope Pattern was created but the file upload failed. Please open it from Edit Scope Pattern and upload the file again.';
              if (!value.idScopePattern) {
                this.spinnerService.hide("bmwSpinner");
                console.error('Create Scope Pattern response has no idScopePattern', value);
                this.errorMessage = uploadFailedMessage;
                this.cdr.markForCheck();
                return;
              }
              const formData = new FormData();
              formData.append('documentFile', this.uploadedFile, this.uploadedFile.name);
              // Success message and navigation happen only after the upload completes successfully;
              // leaving the page earlier would cancel the upload request.
              this.subscriptions.push(this.adminService.updateScopePatternWithFile(formData, value.idScopePattern)
                .subscribe(data => {
                  if (data?.status?.statusCode === 'FAILURE') {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = data.status.errorDetails || uploadFailedMessage;
                    this.cdr.markForCheck();
                    return;
                  }
                  this.onScopePatternAdded();
                },
                  error => {
                    // The upload endpoint can answer 2xx with a body that is not JSON; HttpClient reports that
                    // as an error even though the file was saved. Treat any 2xx status as success.
                    if (error?.status >= 200 && error?.status < 300) {
                      this.onScopePatternAdded();
                      return;
                    }
                    this.spinnerService.hide("bmwSpinner");
                    console.error('Error uploading Scope Pattern file', error);
                    this.errorMessage = error?.error?.status?.errorDetails || uploadFailedMessage;
                    this.cdr.markForCheck();
                  }));
            } else {
              this.onScopePatternAdded();
            }
          }
        },
          error => {
            this.spinnerService.hide("bmwSpinner");
            console.error('Errro updating ScopePattern with file', error);
            const status = error?.error?.status;
            if (status && status.statusCode === 'FAILURE') {
              this.errorMessage = status.errorDetails;
            }
            this.cdr.markForCheck();
          }));
      }
    }
    this.analyticCallScopePatternAdded();
  }

  private onScopePatternAdded() {
    this.spinnerService.hide("bmwSpinner");
    this.resetFields();
    this.toastService.popToast('Scope Pattern added');
    this.inputSeries = '';
    this.inputArea = '';
    this.inputChannel = "undefined";
    this.makeSelected = "undefined";
    this.prevMake = 'undefined';
    this.errorMessage = '';
    this.errorMessageSIB = '';
    this.router.navigate(['/scope-pattern/home']);
  }

  analyticCallScopePatternAdded() {
    let userID = this.authService.getUserName();
    this.analyticsService.trackNewContentAdded(userID, "Scope Pattern", this.makeSelected, this.documentNumber, 'added');
  }

  setRandomDocNumber() {
    if (this.bulletinType == "obd") {
      this.documentNumber = "OD" + Math.floor(100000 + Math.random() * 900000);
      return this.documentNumber;
    } else {
      return '';
    }
  }

  onAddRelatedSIB(bulletinNumber) {
    this.relatedSIBs.push(bulletinNumber);
  }

  formatBulletinNumber(event: any, sibOrVideo: string) {

    if (event.key == "ArrowLeft" || event.key == "ArrowRight" || event.keyCode == 8 || event.keyCode == 65 || event.keyCode == 67 || event.keyCode == 17) { return };
    let tempInput;
    let split = 2;
    let chunk = [];
    // tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");

    if (sibOrVideo === 'sib') {
      tempInput = this.bulletinNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.bulletinNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.bulletinNumber = tempInput.slice(0, 8);

    }
    else if (sibOrVideo === 'scope pattern') {
      tempInput = this.documentNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.documentNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.documentNumber = tempInput.slice(0, 8);

    }
  }

  setDefaultDate(): string {
    let d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

}

function filterSeriesArray(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.length; i++) {
    for (var j = 0; j < filter.length; j++) {
      if (array[i].id === filter[j].id && array[i].seriesName === filter[j].seriesName) {
        myArrayFiltered.push(array[i]);
      }
    }
  }
  return myArrayFiltered;
}